(() => {
  if (customElements.get('announcements-bar')) {
    return;
  }

  class AnnouncementsBar extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        direction: 'vertical',
        loop: true,
        autoplay: {
          delay: this.dataset.autoplaySpeed || 5000,
          pauseOnMouseEnter: true,
        },
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }

    show() {
      this.classList.add('is-loaded');
    }
  }

  customElements.define('announcements-bar', AnnouncementsBar);
})();
